import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SecurityComponent } from './modules/security/security.component';

const routes: Routes = [
  {
    path: 'security',
    component: SecurityComponent,
    loadChildren: () =>
      import('./modules/security/security.module').then(
        (m) => m.SecurityModule,
      ),
  },
  {
    path: '',
    children: [
      {
        path: 'apps',
        loadChildren: () =>
          import('./modules/apps/apps.module').then((m) => m.AppsModule),
      },
      { path: '**', redirectTo: '/apps', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
